<!-- 车主信息 -->
<template>
    <div v-loading="loading">
        <div class="form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="车主名称" prop="CName">
                            <el-input v-model.trim="formData.CName" :disabled="isReadOnly || obj == 'car'" :maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号" prop="PhoneNum">
                            <el-input v-model.trim="formData.PhoneNum" :maxlength="20" :disabled="isReadOnly || obj == 'car'"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-if="!(obj == 'owner' && type == '2')">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-form-item label="车型" prop="CarDesc">
                                <el-input v-model.trim="formData.CarDesc" placeholder="格式：品牌 + 车系 + 排量 + 年款 + 车型" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5" style="padding-top: 5px" v-if="!isReadOnly">
                            <div>
                                <el-button class="btn-primary" style="padding: 8px" @click="$refs.carTypeSelector.show()">选择车型</el-button>
                                <el-button class="btn-primary" style="padding: 8px" @click="uploadBtnClick">识别行驶证</el-button>
                                <input type="file" ref="uploadBtn" accept="image/*" @change="uploadBtnChange($event)" style="opacity: 0; display: none" />
                            </div>
                        </el-col>
                        <!-- <el-col :span="8">
              <el-form-item label="默认车辆">
                <el-switch v-model="formData.IsDefault" :disabled="isReadOnly"></el-switch>
              </el-form-item>
            </el-col> -->
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="车牌号" prop="CarNum">
                                <el-input v-model.trim="formData.CarNum" :disabled="isReadOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车架号">
                                <el-input v-model.trim="formData.VehicleCode" :disabled="isReadOnly"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="发动机号">
                                <el-input v-model.trim="formData.EngineNum" :disabled="isReadOnly"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="默认车辆">
                                <el-switch v-model="formData.IsDefault" :disabled="isReadOnly"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class="dialog-footer">
                <el-button class="btn-primary" @click="submitForm" v-if="!isReadOnly">提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
        <autoSeries ref="carTypeSelector" @chooseResult="chooseResult" />
    </div>
</template>
<script>
import autoSeries from '@/components/common/chooseAutoSeries.vue';
export default {
    // type 1 新增 2 编辑,3查看
    // obj 操作对象，car车辆，owner车主
    // carOwnerData 车主及车辆数据
    props: ['type', 'obj', 'carOwnerData'],
    name: '',
    components: {
        autoSeries
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            isReadOnly: true,
            loading: false,
            canRequest: true,
            formData: {
                CarId: '',
                AutoSId: '',
                CarDesc: '',
                BrandCode: '',
                CarNum: '',
                VehicleCode: '',
                EngineNum: '',
                CId: '',
                CName: '',
                PhoneNum: '',
                EntpId: userMsg.EntpId,
                EntpAccountId: userMsg.EmployeeId,
                EntpAccountName: userMsg.EmployeeName,
                IsDefault: false
            },
            rules: {
                CarDesc: [
                    {
                        required: (this.obj == 'car' && this.type != 3) || (this.obj == 'owner' && this.type == 1),
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CarNum: [
                    {
                        required: (this.obj == 'car' && this.type != 3) || (this.obj == 'owner' && this.type == 1),
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CName: [
                    {
                        required: this.obj == 'owner' && this.type != 3,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    {
                        required: this.obj == 'owner' && this.type != 3,
                        message: '该项必填',
                        trigger: 'blur'
                    },
                    { validator: checkPhone, trigger: 'blur' }
                ]
            }
        };
    },
    mounted() {
        if (this.type == 1) {
            this.isReadOnly = false;
        } else if (this.type == 2) {
            this.isReadOnly = false;
        } else {
            this.isReadOnly = true;
        }
        this.getFormData();
    },
    methods: {
        // 选择车型返回结果
        chooseResult(arr) {
            this.formData.AutoSId = arr.SId;
            this.formData.CarDesc = `${arr.Cn} | ${arr.AutoSerieName} | ${arr.Emission} | ${arr.ProducedYear} | ${arr.SaleModel}`;
            this.formData.BrandCode = `${arr.Cn}|${arr.AutoSerieName}`;
            // 关闭弹框
            setTimeout(() => {
                this.$refs.carTypeSelector.hide();
            }, 1000);
        },
        getFormData() {
            let carOwnerData = { ...this.carOwnerData };
            if (!carOwnerData) return;
            if (this.type == 1) {
                this.formData.CId = carOwnerData.CId;
                this.formData.CName = carOwnerData.Name;
                this.formData.PhoneNum = carOwnerData.PhoneNum;
            } else {
                this.formData.CId = carOwnerData.CId;
                this.formData.CName = carOwnerData.Name;
                this.formData.PhoneNum = carOwnerData.PhoneNum;
                this.formData.CarId = carOwnerData.CarId;
                this.formData.AutoSId = carOwnerData.AutoSId;
                this.formData.CarDesc = carOwnerData.CarDesc;
                this.formData.BrandCode = carOwnerData.BrandCode;
                this.formData.CarNum = carOwnerData.CarNum;
                this.formData.VehicleCode = carOwnerData.VehicleCode;
                this.formData.EngineNum = carOwnerData.EngineNum;
                this.formData.IsDefault = carOwnerData.IsDefault;
            }
        },
        uploadBtnClick() {
            this.$refs.uploadBtn.click();
        },
        uploadBtnChange(e) {
            let that = this;
            let imgfile = this.$refs.uploadBtn;
            for (let i = 0; i < imgfile.files.length; i++) {
                if (!that.uploadCheck(imgfile.files[i])) {
                    return;
                }

                that.loading = true;
                let reader = new FileReader();
                reader.readAsDataURL(imgfile.files[i]);
                reader.onload = function () {
                    let imgBase64 = this.result.split(',')[1];
                    let fd = new window.FormData();
                    fd.append('imgBase64', imgBase64);
                    let xhr = new XMLHttpRequest();
                    xhr.open('POST', '/api/Auto/DrivingLicenseRecognition', true);
                    xhr.setRequestHeader('access-key', that.userMsg.token);
                    xhr.setRequestHeader('reqApp', 'yqgPC');
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            let result = JSON.parse(xhr.responseText);
                            if (result.errcode == 0 && result.data) {
                                that.$util.successMsg('识别成功');
                                let data = result.data;
                                that.formData.AutoSId = data.autoSerieId;
                                that.formData.CarDesc = `${data.brandName ? data.brandName : ''}${data.autoSerieName ? ' | ' + data.autoSerieName : ''}${
                                    data.emission ? ' | ' + data.emission : ''
                                }${data.modelYear ? ' | ' + data.modelYear : ''}${data.saleName ? ' | ' + data.saleName : ''}`;
                                // that.formData.BrandCode = data.brandAutoSerie;
                                that.formData.CName = data.owner;
                                that.formData.CarNum = data.plate_num;
                                that.formData.VehicleCode = data.vin;
                                that.formData.EngineNum = data.engine_num;
                                that.loading = false;
                            } else {
                                that.$util.errorMsg('识别失败');
                            }
                        }
                        that.loading = false;
                    };
                    xhr.onerror = () => {
                        that.$util.errorMsg('识别失败');
                        that.loading = false;
                    };
                    xhr.send(fd);
                };
            }
        },
        uploadCheck(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            //改成10M
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt10M) {
                this.$util.warningMsg('上传图片大小不能超过 10MB!');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt10M;
        },
        // 提交表单
        submitForm() {
            if (!this.canRequest) {
                return;
            }
            this.$refs.formData.validate(valid => {
                let that = this;

                if (valid) {
                    that.loading = true;
                    that.canRequest = false;
                    let url = '/api/CustomerManagement/EditCar';
                    if (that.obj == 'owner') {
                        url = '/api/CustomerManagement/EditCarOwner';
                    }
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData,
                            hideLoading: true
                        })
                        .then(resp => {
                            if (resp.errcode == 0) {
                                that.$util.successMsg('保存成功');
                                that.$emit('closeDialog', true);
                            }
                            that.loading = false;
                            setTimeout(() => {
                                that.canRequest = true;
                            }, 1000);
                        })
                        .catch(() => {
                            that.loading = false;
                            that.canRequest = true;
                        });
                }
            });
        },

        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
</style>
